const css = `._7GtQCW__compPagination{justify-content:center;align-items:center;display:flex}._7GtQCW__compPagination ._7GtQCW__pages{font-family:var(--typography-font-sans);user-select:none;padding:0 16px;font-size:12px;display:inline-block}`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};

export default {"compPagination":"_7GtQCW__compPagination","pages":"_7GtQCW__pages"};
